// extracted by mini-css-extract-plugin
var _1 = "styles-module__downloadModalContainer___t8XsS";
var _2 = "styles-module__dropdownContainer___pdeqa";
var _3 = "styles-module__fullWidth___TtNV3";
var _4 = "styles-module__medium___oIY2t";
var _5 = "styles-module__modalSubText___myxKz";
export { _1 as "downloadModalContainer", _2 as "dropdownContainer", _3 as "fullWidth", _4 as "medium", _5 as "modalSubText" }
